import React from "react"
import BlogLayout from "../../gatsby-theme-blog/components/layout"
import favicon from "../../images/favicon.ico"
import Helmet from "react-helmet"

export default props => {
  return (
    <BlogLayout {...props}>
      <Helmet>
        <link rel="icon" href={favicon} />
      </Helmet>
      {props.children}
      {/*<BlogHomeFooter {...props} />*/}
    </BlogLayout>
  )
}
